import { render, staticRenderFns } from "./CheckpointComponent.vue?vue&type=template&id=5b3c536f&scoped=true&"
import script from "./CheckpointComponent.vue?vue&type=script&lang=js&"
export * from "./CheckpointComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointComponent.vue?vue&type=style&index=0&id=5b3c536f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c536f",
  null
  
)

export default component.exports